import React from 'react';
import {Box, Typography} from '@mui/material';
import {BuilderPot_dentistChildren} from '../../../schema-types/BuilderPot';
import {PlanAccordionShell} from '../CreateBuilder/BuilderSourceDestination/PlanAccordionShell';
import {PlanSelector} from '../CreateBuilder/BuilderSourceDestination/PlanSelector';

import {getSubplanSummaryParts} from '../CreateBuilder/BuilderSourceDestination/builderNaming';
import {BuilderContributeAmounts} from './BuilderContributeAmounts';

interface ContributeDestinationSubplanProps {
  subPlan: BuilderPot_dentistChildren;
  isSelected: boolean;
  handleChange: () => void;
}

export const ContributeDestinationSubplan: React.FC<
  ContributeDestinationSubplanProps
> = ({subPlan, isSelected, handleChange}) => {
  return (
    <Box
      id={subPlan.id}
      data-recc-id={subPlan.originalOvrId ?? 'New plan'}
      data-selected={isSelected ? 'selected' : 'not-selected'}
      data-is-subplan="true"
      data-test="choice-option"
    >
      <PlanAccordionShell
        expanded={isSelected}
        isSelected={isSelected}
        isSoleParent={false}
        flat
        compact
        validationLevel="nothing"
        summaryChildren={
          <>
            <PlanSelector
              mode="single"
              id={subPlan.id}
              isSelected={isSelected}
              handleChange={handleChange}
            />
            <Box
              display="flex"
              flex={1}
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="body2">
                {getSubplanSummaryParts(subPlan).label}
              </Typography>
              {getSubplanSummaryParts(subPlan).currentValue && (
                <Typography variant="body2" sx={{ml: 2, whiteSpace: 'nowrap'}}>
                  {getSubplanSummaryParts(subPlan).currentValue}
                </Typography>
              )}
            </Box>
          </>
        }
      >
        {isSelected && <BuilderContributeAmounts disabled />}
      </PlanAccordionShell>
    </Box>
  );
};
